<div class="modal-header py-2 bg-light">
  <h5 class="modal-title">{{ 'common.exportGGSheets' | transloco }}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco"
          (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body bg-light p-0" *transloco="let t">
  <div class="bg-white" [class.mb-3]="!progressState.isFinal">
    <!--- Chọn dữ liệu ------------------------------------------------------------------>
    <div class="p-3 pb-1">
      <div class="row">
        <div class="col-xl-2 col-12 my-0">
          <label class="form-label fw-semibold">
            {{ t('common.selectData') }}:
          </label>
        </div>
        @if (options.excelListPage) {
          <div class="d-flex flex-wrap gap-3 col-xl-10 col-12">
            @for (page of options.excelListPage.list; track page) {
              <div class="me-xl-4 me-0">
                <app-checkbox
                  [options]="{
 componentType: 'form-switch',
 type: 'radio',
 name: 'isListPages',
 color: 'success'
 }"
                  [value]="page.key"
                  [label]="t(page.value)"
                  [checked]="page.key == state.pageSelection"
                  (valueChange)="state.pageSelection = $event"
                />
              </div>
            }
          </div>
        }
      </div>
    </div>
    <!--- End Chọn dữ liệu ------------------------------------------------------------------>

  </div>
  @if (!progressState.isExportSubmit) {
      @if (isLoadingTabGGSheet) {
        @if (googleAccountEmail) {
          <!-- Tài khoản Google đã lưu của user (một tài khoản/user, quản lý ở Cài đặt chung) -->
          <div class="px-3 pb-3">
            {{ t('common.account.youConnectToAcc') }}
            <b class="text-primary">{{ googleAccountEmail }}</b>
          </div>
          <div class="row w-100 p-3 pt-0">
            <!---- Bảng tính ----->
            <div class="col-xl-6 col-12" data-title="Bảng tính">
              <h6 class="fw-semibold mb-3">{{ t('excel.worksheet') }}</h6>
              <div class="d-flex align-items-center mb-3">
                <!-- Tạo file mới -->
                <app-checkbox
                  [classBox]="'me-2'"
                  [value]="TYPE_USE.NEW"
                  [checked]="state.typeUseFile === TYPE_USE.NEW"
                  [options]="{type: 'radio', name: 'typeUseFile'}"
                  (valueChange)="onChangeTypeUseFile($event)"
                />
                <!-- Tạo file mới & điền tên file -->
                <app-floating-invalid class="flex-1" [errorOriginal]="errors['fileNew.fileName']"
                                      data-title="Tạo bảng tính mới">
                  <input type="text"
                         class="form-control"
                         placeholder="Nhanh.vn_Order"
                         [disabled]="state.typeUseFile !== TYPE_USE.NEW"
                         [class.border-danger]="!!errors['fileNew.fileName']"
                         [class.pe-4]="!!errors['fileNew.fileName']"
                         (ngModelChange)="onChangeValue('fileNew.fileName', $event)"
                         [(ngModel)]="state.fileNew.fileName">
                  <label>{{ t('googleSheets.create.newSpreadsheet') }}</label>
                </app-floating-invalid>
              </div>
              <div class="d-flex align-items-center">
                <!-- Dùng file Google Sheets có sẵn -->
                <app-checkbox
                  [classBox]="'me-2'"
                  [value]="TYPE_USE.AVAILABLE"
                  [checked]="state.typeUseFile === TYPE_USE.AVAILABLE"
                  [options]="{type: 'radio', name: 'typeUseFile'}"
                  (valueChange)="onChangeTypeUseFile($event)"
                />
                <div class="flex-1" data-title="Điền link file có sẵn">
                  <app-floating-invalid [errorOriginal]="errors['spreadId']">
                    <input type="text"
                           class="form-control showPlaceholder"
                           placeholder="https://docs.google.com/spreadsheets/..."
                           [disabled]="state.typeUseFile !== TYPE_USE.AVAILABLE"
                           [class.border-danger]="!!errors['spreadId']"
                           [class.pe-4]="!!errors['spreadId']"
                           [(ngModel)]="state.googleFile.spreadUrl"
                           (change)="onChangeSpreadGGUrl(state.googleFile.spreadUrl)"
                    >
                    <label class="focusIn">{{ t('googleSheets.enter.existingFileLink') }}</label>
                  </app-floating-invalid>
                </div>
              </div>
              @if (state.googleFile.spreadUrl && !errors['spreadId']) {
                <a
                  [href]="state.googleFile.spreadUrl"
                  [style.margin-left.rem]="1.7"
                  target="_blank" class="btn btn-light fw-semibold mt-2">
                  {{ t('common.view.file') }}
                </a>
              }
            </div>
            <!---- Trang tính ----->
            <div class="col-xl-6 col-12" data-title="Trang tính">
              <h6 class="fw-semibold mt-2 mt-lg-0 mb-3">{{ t('excel.spreadsheet') }}</h6>
              <div>
                <div class="d-flex align-items-center mb-3">
                  <app-floating-invalid class="flex-1"
                                        [errorOriginal]="errors['spreadSheetNewTitle']">
                    <input type="text"
                           class="form-control"
                           placeholder="Nhanh.vn_Order_y-m-d_h_i_s"
                           [class.border-danger]="!!errors['spreadSheetNewTitle']"
                           [class.pe-4]="!!errors['spreadSheetNewTitle']"
                           (ngModelChange)="onChangeValue('spreadSheetNewTitle', $event)"
                           [(ngModel)]="state.googleFile.spreadSheetNewTitle">
                    <label>Tên trang tính mới</label>
                  </app-floating-invalid>
                </div>
              </div>
            </div>
          </div>
        } @else if (googleAccountLoadError) {
          <div class="w-100 p-3 pt-0 text-center">
            <div class="alert alert-danger fw-semibold" role="alert">
              {{ t('feature.exportData.googleAccountLoadError') }}
            </div>
            <button type="button" class="btn btn-primary fw-semibold"
                    (click)="loadDepsDataGoogleSheet()">
              {{ t('common.retry') }}
            </button>
          </div>
          <div class="d-flex justify-content-end bg-white w-100 p-3">
            <button type="button" class="btn btn-light btn-sm fw-semibold" (click)="activeModal.dismiss()">
              {{ t('common.close') }}
            </button>
          </div>
        } @else {
          <!-- Như v1: chưa có email đã lưu thì dẫn sang Cài đặt chung để kết nối -->
          <div class="w-100 p-3 pt-0 text-center" data-title="Yêu cầu kết nối tài khoản">
            <div class="alert alert-warning fw-semibold">
              {{ t('export.data.noAccessToken') }}
            </div>
            <a class="btn btn-primary fw-semibold"
               [routerLink]="SETTING_GENERAL_URI"
               (click)="activeModal.dismiss()">
              <i class="ph ph-google-logo"></i>
              <span class="ms-2">{{ t('common.setting.connectAccGoogle') }}</span>
            </a>
          </div>
          <div class="d-flex justify-content-end bg-white w-100 p-3">
            <button type="button" class="btn btn-light btn-sm fw-semibold" (click)="activeModal.dismiss()">
              {{ t('common.close') }}
            </button>
          </div>
        }
        <!----- Yêu cầu cấp & xác nhận token ---------------------------------------------------------------->
      } @else {
        <div class="p-3 pt-0 text-center">
          <app-spin-loader/>
          <h6>{{ 'common.messages.loading' | transloco }}.</h6>
        </div>
      }
  }
  @if (googleAccountEmail) {
    <app-export-data-columns [exportData]="this"/>
    <div class="bg-white w-100 p-3">
      @if (progressState.isError && progressState.spreadData?.spreadUrl) {
        <div class="alert alert-warning fw-semibold" role="alert">
          <div class="mb-2">
            {{ t('feature.exportData.googleSheetPartialExport', {count: progressState.currentItem}) }}
          </div>
          <a [href]="progressState.spreadData?.spreadUrl" class="btn btn-primary btn-sm" target="_blank" rel="noopener">
            <i class="ph ph-arrow-square-out me-2"></i>
            {{ t('common.open.file') }} Google Sheets
          </a>
        </div>
      }
      @if (progressState.isFinal) {
        <div class="alert alert-success fw-semibold">
          <!-- Xuất file Google Sheets thành công -->
          <div class="mb-2">
            <i class="ph ph-check text-success me-2"></i>
            <span>{{ t('export.data.googleSheetsSuccess') }}</span>
          </div>
          <a [href]="progressState.spreadData?.spreadUrl" class="btn btn-primary btn-sm" target="_blank">
            <i class="ph ph-arrow-square-out me-2"></i>
            {{ t('common.open.file') }} Google Sheets
          </a>
        </div>
      }
      <div class="d-lg-flex align-items-center justify-content-between">
        <!--- Process ------------------------------------------------------------------>
        @if (progressState.isExportSubmit && !progressState.isFinal) {
          <div
            class="d-flex flex-auto mb-3 mb-lg-0 me-lg-4">
            <p class="mb-0 me-3">
              <i class="ph ph-caret-up me-3"></i>
              {{ t('common.exportingData') }}:
              <span>{{ progressState.currentItem }}</span>
              @if (progressState.totalPages > 0) {
                / <span>{{ progressState.totalItems }}</span>
              }
            </p>
            <div class="flex-1">
              <app-progress-bar
                [totalPages]="progressState.totalPages"
                [currentPage]="progressState.currentPage"/>
            </div>
          </div>
        }
        <!--- End Process ------------------------------------------------------------------>
        <div class="d-flex flex-auto flex-lg-1 justify-content-end">
          @if (!progressState.isFinal) {
            <button type="button" class="btn btn-primary btn-sm text-nowrap fw-semibold"
                    [disabled]="progressState.isExportSubmit || !googleAccountEmail"
                    (click)="onExportData()">
              {{ t('common.exportData') }}
            </button>
          }
          <button type="button" class="btn btn-light btn-sm text-nowrap ms-3 fw-semibold"
                  (click)="activeModal.dismiss()">
            {{ t('common.close') }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
